const { getElement, getElements } = window.BAO.Utils;
class PushCompatibleProducts extends window.BAO.CustomElement() {
  static get requiredAttributes() {
    return ["data-type", "data-product-handle"];
  }

  static get requiredElements() {
    return ["radio", "confirm"];
  }

  connectedCallback() {
    super.connectedCallback();

    if (!this.isLegacy) return;

    this.render();
  }

  setupListeners() {
    super.setupListeners();

    if (this.isLegacy) return;

    this.setupRadioChangeHandler();
  }

  async render() {
    const html = await this.variationOptionHTML();

    if (!html.length) {
      this.remove();
      return;
    }

    this.els.options.element.innerHTML = html;

    this.afterRender();
  }

  afterRender() {
    this.setupRadioChangeHandler();
    this.checkRadioOnLoad();
  }

  checkRadioOnLoad() {
    const radioEls = getElements(this.els.radio.selector, { context: this });
    const checkedRadio = radioEls.find((radio) => radio.checked);
    if (!checkedRadio) {
      const addToCartButtons = getElements("[data-product-add-to-cart]");
      addToCartButtons.forEach((button) => {
        if (button.classList.contains("btn-Button-disabled")) {
          button.addEventListener("click", () => {
            if (!button.classList.contains("btn-Button-disabled")) {
              return;
            }

            const prdCompatibleProducts = document.querySelector(
              ".prd-CompatibleProducts",
            );
            if (!prdCompatibleProducts) return;

            // Scroll into view
            prdCompatibleProducts.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });

            // Add shake animation
            setTimeout(() => {
              prdCompatibleProducts.classList.add(
                "prd-CompatibleProducts-error",
              );
            }, 1000);

            // Remove shake animation
            setTimeout(() => {
              prdCompatibleProducts.classList.remove(
                "prd-CompatibleProducts-error",
              );
            }, 2500);
          });
        }
      });
    }
  }

  setupRadioChangeHandler() {
    const radioEls = getElements(this.els.radio.selector, { context: this });

    radioEls.forEach((radioEl) => {
      this.listeners.add(radioEl, "change", this.handleChange.bind(this));
      if (!radioEl.value) {
        radioEl.checked = false;
        const productForm = document.querySelector(
          "#product-form-template-product",
        );
        const addToCartButton = productForm.querySelector(
          "[data-product-add-to-cart]",
        );
        addToCartButton.textContent = window.theme.strings.selectPowerSource;
        addToCartButton.classList.add("btn-Button-disabled");
        addToCartButton.type = "button";
      }
    });
  }

  handleChange(event) {
    if (!this.externalValueEl || !event.target.dataset?.title) return;

    this.externalValueEl.textContent = event.target.dataset.title;

    const addToCartButtons = getElements("[data-product-add-to-cart]");

    addToCartButtons.forEach((button) => {
      button.textContent = window.theme.strings.addToCart;
      button.classList.remove("btn-Button-disabled");
      button.type = "submit";
    });

    this.els.confirm?.element?.click();
  }

  async variationOptionHTML() {
    const { type, productHandle } = this.dataset;

    const html =
      window.sessionStorage.getItem(this.storageKey) ||
      (await window.BAO.sectionRenderer.fetchSingle(
        `push-compatible-product-options-${type}`,
        `/products/${productHandle}`,
      ));

    window.sessionStorage.setItem(this.storageKey, html);

    return window.BAO.sectionRenderer.getInnerHtml(html);
  }

  get storageKey() {
    return `push-compatible-products-${this.dataset.productHandle}-${this.dataset.type}`;
  }

  get externalValueEl() {
    if (!this.externalEls?.value?.selector) return;

    return getElement(
      `${this.externalEls.value.selector}[data-type="${this.dataset?.type}"]`,
    );
  }

  get isLegacy() {
    return this.els?.options?.exists;
  }
}

if (!customElements.get("push-compatible-products")) {
  customElements.define("push-compatible-products", PushCompatibleProducts);
}
